import { useEffect } from 'react';

interface UseLeadsFunnelsPageEffectsProps {
  funnelIdParam: string | null;
  isFunnelListReady: boolean;
  applyFunnelIdParam: (funnelIdParam: string) => void;
}

export const useLeadsFunnelsPageEffects = ({
  funnelIdParam,
  isFunnelListReady,
  applyFunnelIdParam,
}: UseLeadsFunnelsPageEffectsProps) => {
  useEffect(() => {
    if (funnelIdParam === null || !isFunnelListReady) return;

    applyFunnelIdParam(funnelIdParam);
  }, [applyFunnelIdParam, funnelIdParam, isFunnelListReady]);
};
